import { Shield, Award, CheckCircle, Phone, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import expertImage from "@/assets/thomas-dewein-expert.webp";
const ExpertSection = () => {
  return <section className="py-12 sm:py-16 lg:py-20 px-2 sm:px-3 md:px-4">
      <div className="container mx-auto max-w-7xl">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background with gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-accent/5 via-transparent to-accent/10" />
          
          <div className="relative backdrop-blur-xl bg-white/[0.02] border border-white/10 rounded-3xl shadow-2xl">
            <div className="grid lg:grid-cols-[45%_55%] gap-0">
              {/* Linke Spalte - Bild */}
              <div className="relative h-[350px] sm:h-[450px] lg:h-[600px]">
                <img src={expertImage} alt="Thomas Dewein - Ihr Experte für Cyberversicherung" className="absolute inset-0 w-full h-full object-contain object-center lg:object-[65%_center] rounded-t-3xl lg:rounded-l-3xl lg:rounded-tr-none" width="600" height="600" />
                
                {/* Gradient Overlay nur mobile/tablet */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent lg:hidden rounded-t-3xl" />
                
                {/* Floating Badge */}
                <div className="absolute top-3 sm:top-4 left-1/2 -translate-x-1/2 sm:left-8 sm:translate-x-0">
                  
                </div>

                {/* Experience Badge */}
                <div className="absolute -bottom-3 sm:-bottom-4 lg:bottom-8 left-1/2 -translate-x-1/2">
                  <div className="backdrop-blur-xl bg-black/50 border border-accent/40 rounded-xl px-4 py-1 sm:px-6 sm:py-1.5 shadow-lg">
                    <div className="flex items-center gap-1 sm:gap-1.5">
                      <div className="text-sm sm:text-base font-bold text-accent">15+</div>
                      <div className="text-[10px] sm:text-xs text-white/80 whitespace-nowrap">Jahre Erfahrung</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Rechte Spalte - Content */}
              <div className="p-5 sm:p-8 md:p-10 lg:p-12 flex flex-col justify-center">
                <div className="space-y-6 sm:space-y-5 md:space-y-6">
                  <div>
            <h2 className="text-lg sm:text-3xl lg:text-4xl font-bold text-white mb-4 sm:mb-4 leading-tight text-center">
              Bereit für optimalen<br />
              <span className="bg-gradient-to-r from-accent to-accent/70 bg-clip-text text-transparent">
                Schutz?
              </span>
            </h2>
                    
                    <p className="text-sm sm:text-base md:text-lg text-gray-300/90 text-center">
                      Mit <span className="font-semibold text-white">Thomas Dewein</span> und seinem erfahrenen Team an Ihrer Seite.
                    </p>
                  </div>

                  {/* Qualifikationen */}
                  <div className="space-y-2.5 sm:space-y-2 md:space-y-3 pt-5 sm:pt-3">
                    <div className="group flex items-center gap-2 sm:gap-2.5 md:gap-3 cursor-pointer transition-all duration-300 hover:translate-x-1">
                      <div className="flex-shrink-0">
                        <div className="p-1.5 sm:p-2 rounded-lg bg-gradient-to-br from-accent/10 to-accent/5 border border-accent/20 group-hover:from-accent/20 group-hover:to-accent/10 group-hover:border-accent/60 group-hover:scale-110 group-hover:shadow-[0_0_30px_rgba(139,195,74,0.4)] transition-all duration-300">
                          <Award className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-accent group-hover:rotate-12 group-hover:text-accent/90 transition-all duration-300" />
                        </div>
                      </div>
                      <p className="text-[9px] sm:text-xs md:text-sm text-white/90 font-medium leading-tight group-hover:text-white group-hover:scale-[1.02] transition-all duration-300 text-center">
                        Fachwirt für Versicherung und Finanzen (IHK)
                      </p>
                    </div>

                    <div className="group flex items-center gap-2 sm:gap-2.5 md:gap-3 cursor-pointer transition-all duration-300 hover:translate-x-1">
                      <div className="flex-shrink-0">
                        <div className="p-1.5 sm:p-2 rounded-lg bg-gradient-to-br from-accent/10 to-accent/5 border border-accent/20 group-hover:from-accent/20 group-hover:to-accent/10 group-hover:border-accent/60 group-hover:scale-110 group-hover:shadow-[0_0_30px_rgba(139,195,74,0.4)] transition-all duration-300">
                          <Award className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-accent group-hover:rotate-12 group-hover:text-accent/90 transition-all duration-300" />
                        </div>
                      </div>
                      <p className="text-[9px] sm:text-xs md:text-sm text-white/90 font-medium leading-tight group-hover:text-white group-hover:scale-[1.02] transition-all duration-300 text-center">
                        Technischer Underwriter (DVA)
                      </p>
                    </div>

                    <div className="group flex items-center gap-2 sm:gap-2.5 md:gap-3 cursor-pointer transition-all duration-300 hover:translate-x-1">
                      <div className="flex-shrink-0">
                        <div className="p-1.5 sm:p-2 rounded-lg bg-gradient-to-br from-accent/10 to-accent/5 border border-accent/20 group-hover:from-accent/20 group-hover:to-accent/10 group-hover:border-accent/60 group-hover:scale-110 group-hover:shadow-[0_0_30px_rgba(139,195,74,0.4)] transition-all duration-300">
                          <Award className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-accent group-hover:rotate-12 group-hover:text-accent/90 transition-all duration-300" />
                        </div>
                      </div>
                      <p className="text-[9px] sm:text-xs md:text-sm text-white/90 font-medium leading-tight group-hover:text-white group-hover:scale-[1.02] transition-all duration-300 text-center">
                        Experte für Cyberversicherung (DVA)
                      </p>
                    </div>
                  </div>

                  {/* Werbetext */}
                  <div className="pt-5 sm:pt-4 md:pt-5">
                    <p className="text-xs sm:text-sm md:text-base lg:text-lg text-center text-white/90 font-medium leading-relaxed">
                      Mit über 558 Arztpraxen und Krankenhäusern wissen wir, worauf es ankommt
                    </p>
                  </div>

                  {/* CTA Button */}
                  <div className="pt-6 sm:pt-5 md:pt-6 flex justify-center">
                    <Link to="/team">
                      <Button variant="outline" size="lg" className="group bg-gradient-to-r from-accent/10 to-accent/5 border-accent/40 hover:border-accent hover:bg-accent/20 text-white font-semibold shadow-lg hover:shadow-[0_0_25px_rgba(139,195,74,0.3)] transition-all duration-300">
                        <Users className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" />
                        <span>Unser Team kennenlernen</span>
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ExpertSection;